import React from "react";
import styled from "styled-components";
import Layout from "../components/layout";
import SEO from "../components/seo";
import { InternalLink, ExternalLink, EmailLink } from "../components/sitelinks";
import {
    MainContainer,
    BoxContainer,
    BoxHeading,
    SubHeading,
    LargeSubHeading,
    BoxCopy
} from "../components/simplepagelayout";

const WarningDiv = styled.div`
    border-style: solid;
    border-color: red;
    border-width: 1px;
    padding: 1em;
    margin-bottom: 1em;
`;

const BoxPreHeading=styled.div`
  font-size: 1.1em;
  padding-bottom: 1.5em;
  font-weight: 500;
`;

const SoftwarePage = () => (
    <Layout>
    <SEO title= "Software" />
    <MainContainer>
      <BoxContainer>
          <BoxPreHeading>
            To purchase Contour Rig Tools, visit the <ExternalLink href="https://store.notionalpipe.com">Notional Pipe Store.</ExternalLink>
          </BoxPreHeading>
        <BoxHeading>
        Download Contour Rig Tools v1.0.12.1
        </BoxHeading>
        <BoxCopy>
        <p>
         <div>
            <ExternalLink href="https://downloads.notionalpipe.com/releases/v1_0_12_1/Contour_v1.0.12.1_windows_maya2020_2026.zip">Download Rig Tools for Windows</ExternalLink>
         </div>
         <div>
            <ExternalLink href="https://downloads.notionalpipe.com/releases/v1_0_12_1/Contour_v1.0.12.1_linux_maya2020_2026.tgz">Download Rig Tools for Linux</ExternalLink>
         </div>
         <div>
            <ExternalLink href="https://downloads.notionalpipe.com/releases/v1_0_12_1/Contour_v1.0.12.1_macOS_maya2020_2026.zip">Download Rig Tools for macOS</ExternalLink>
         </div>
        </p>

        <p>Contour Rig Tools runs in either animator mode or rigger mode, using the same plug-in, and includes a free 30-day trial of rigger mode.</p>
        <p>Animator mode is always free of charge, and allows animating using any Rig Tools rig.
        Only creating Contour rigs requires purchasing a license.</p>
        <p>Contour currently supports Maya 2020 through Maya 2026. Only the latest update of each version is officially supported, although Contour may work with earlier updates. We do not support Maya 2023.0, Maya 2023.1, or Maya 2024.0. If you are running Maya 2023, it must be Maya 2023.2 or later. If you are running Maya 2024, it must be Maya 2024.1 or later.</p>

        {/* For some reason we need to encase WarningDiv in an extra div,
            otherwise it'll disappear when the user reloads the page */}
        <div>
            <WarningDiv>
               <p><strong>Important Note</strong></p>

               <p>
            There are a number of issues that can affect rigs made with Contour when Cached Playback is enabled. These appear to be bugs in Maya's implementation, and we have filed bug reports about them with Autodesk.
            </p>

               <div>
            Fortunately, there are fairly straightforward workarounds for them. We recommend reading the entire <ExternalLink href="https://manuals.notionalpipe.com/rigtools/11-caveats/11-caveats.html">Caveats</ExternalLink> section of the manual, but if you animate with Cached Playback enabled, we strongly recommend reading <ExternalLink href="https://manuals.notionalpipe.com/rigtools/11-caveats/11-caveats.html#issues-related-to-cached-playback">the section related to Cached Playback.</ExternalLink>
               </div>
            </WarningDiv>
        </div>

        <p>
           <div>
              <InternalLink to="/contourpatchnotes">See the Contour Rig Tools patch notes</InternalLink>
           </div>

           <div>
              <InternalLink to="/contourversions">Download previous versions of Rig Tools</InternalLink>
           </div>
        </p>
        </BoxCopy>
      </BoxContainer>

      <BoxContainer id="purchase">
        <BoxHeading>
          Purchase Contour Rig Tools
        </BoxHeading>
        <BoxCopy>
        <p>Contour Rig Tools is offered on a subscription basis. You can purchase a new subscription and manage your existing subscriptions at the <ExternalLink href="https://store.notionalpipe.com">Notional Pipe Store.</ExternalLink></p>

        </BoxCopy>
        <LargeSubHeading>
           Pricing
        </LargeSubHeading>
        <BoxCopy>
        <SubHeading>
           Animator Mode: FREE
        </SubHeading>
           <p>Contour Rig Tools animator mode is always free. This means that rigs you create with Contour's
    rigger mode can be animated by any number of animators, free of charge. Animator mode allows animating with Contour rigs, and adding bone cvs to those rigs as needed.</p>

        <SubHeading>
           Rigger Mode
        </SubHeading>
          <p>Contour Rig Tools rigger mode subscriptions can be purchased as either node-locked licenses or floating licenses. Rigger mode activates all of the features needed to create Contour rigs. The pricing is the same for node-locked and floating licenses:</p>
<ul>
<li>$50.00 / month for one month</li>
<li>$45.00 / month for six months</li>
<li>$40.00 / month for twelve months</li>
</ul>
        <p>The discounts for six months or more are combined over more than one seat within a subscription. For instance, the discount for an annual subscription would also apply to a six month subscription with two seats.</p>

        <p>Floating licenses cannot currently be purchased through the Notional Pipe Store. If you wish to purchase floating licenses, please contact us at <EmailLink href="mailto:sales@notionalpipe.com">sales@notionalpipe.com</EmailLink> and we will assist you in setting up a floating license server.</p>

        <p>Note that paid licenses are not necessary to animate or render with Rig Tools rigs, only to create and modify them.</p>
        </BoxCopy>
        </BoxContainer>
        <BoxContainer>
        <BoxHeading>
           Other Services
        </BoxHeading>
        <BoxCopy>
          <p>
            If your company is interested in making other licensing arrangements, interested in training, premium support or custom development, or has other needs Notional Pipe can meet, email us at <EmailLink href="mailto: business@notionalpipe.com">business@notionalpipe.com</EmailLink>.
          </p>
        </BoxCopy>
        </BoxContainer>

        </MainContainer>
    </Layout>
);

export default SoftwarePage;
